<i (mouseenter)="hover = true"
  [matTooltip]="tooltip()"
  matTooltipPosition="left"
  (mouseleave)="hover = false"
[class]="hover ? 'ca-info' : ok ? 'ca-check' : 'ca-warning'"></i>

@if (result?.location) {
  <i
    (mouseenter)="locationHover = true"
    [matTooltip]="locationTooltip()"
    matTooltipPosition="left"
    (mouseleave)="locationHover = false"
  [class]="locationHover ? 'ca-info' : 'ca-my_location'"></i>
}